<template>
  <div class="c2-task-main" v-if="bodyShow">
    <h2>{{title}}</h2>

    <div v-for="(item,index) in list" :key="index">
      <!-- title -->
      <div v-if="item.type == 'title'" :class="['c2-task-group']">
        <h3 v-html="doFontColor(item)" v-if="item.label"></h3>
        <h4 v-if="item.config.type=='max'" class="cpuTotal">{{getMax(cpuTotal)}}</h4>
      </div>
      <!--  -->
      <!-- 自由对话组件 -->
      <public-dialogue
        v-if="data.testid&&data.testid != 0 && index==0"
        :testid="data.testid"
        :cid="$route.query.cid"
        :taskid="$route.query.id"
      ></public-dialogue>
      <!--  -->
      <!-- textarea -->
      <div v-if="item.type == 'subtitle'" :class="['c2-task-group','subtitle']">
        <h3 v-html="doFontColor(item)" v-if="item.label"></h3>
      </div>
      <!-- evaluation -->
      <div v-if="item.type == 'evaluation'" class="c2-task-group">
        <!-- 类型 -->
        <div v-if="item.config.type=='type'">
          <h3 v-html="doFontColor(item)"></h3>
          <h4 class="pdl3">{{item.config.content}}</h4>
        </div>
        <!-- 得分 -->
        <div v-if="item.config.type=='star'">
          <h3 v-html="doFontColor(item)"></h3>
          <div class="star pdl3">
            <img src="@a/select-star.png" v-for="item in item.config.content" :key="item" alt />
            <img src="@a/star.png" v-for="item in (star_num-item.config.content)" :key="item" alt />
          </div>
        </div>
      </div>
      <!-- text -->
      <div v-if="item.type == 'text'" class="c2-task-group text">
        <h3 v-html="doFontColor(item)" v-if="item.label"></h3>
        <input
          class="c2-input"
          @input="textareaChange(index,item.content,item.id,item.config.word)"
          v-model="item.content"
          :placeholder="item.config.placeholder"
        />
        <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
      </div>
      <!-- checkbox -->
      <!-- {{item.label}} -->
      <div v-if="item.type == 'checkbox'" class="c2-task-group">
        <h3 v-html="doFontColor(item)"></h3>
        <div class="c2-task-checkbox">
          <van-checkbox-group v-model="item.content">
            <van-checkbox
              :class="[(index2==0 || index2 ==1 || index2 ==2) ?'c2-checkbox':'']"
              @click="check(item2,item.content,item.config.word,item.id)"
              v-for="(item2,index2) in item.config.content"
              :key="index2"
              :disabled="(item.content.indexOf(item2)<0 )&& item.content.length>=item.config.word"
              :name="item2"
            >{{item2}}</van-checkbox>
          </van-checkbox-group>
        </div>
      </div>
      <!-- textarea -->
      <div v-if="item.type == 'textarea'" :class="['c2-task-group','text']">
        <h3 v-html="doFontColor(item)" v-if="item.label"></h3>
        <textarea
          class="c2-textarea"
          @input="textareaChange(index,item.content,item.id,item.config.word)"
          v-model="item.content"
          :placeholder="item.config.placeholder"
        ></textarea>
        <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
      </div>
      <!-- select -->
      <div v-if="item.type == 'select'" class="task-select-group">
        <h3 v-html="doFontColor(item)" v-if="item.label"></h3>
        <div class="flex-select-group">
          <div
            v-for="(itemSelect,sIdx) in item.config.text"
            :key="sIdx"
            :class="['select-group',itemSelect.display=='block'?'on':'']"
          >
            <input
              readonly
              type="text"
              v-model="item.content[sIdx]"
              @click="selectPicker(itemSelect.attr,item.config.variable,item.id,index,sIdx)"
              :placeholder="itemSelect.placeholder"
            />
            <img src="@a/bottom.png" alt />
          </div>
        </div>
      </div>
      <!-- calculating -->
      <div v-if="item.type == 'calculating'" class="calculating-group">
        <h3 v-html="doFontColor(item)"></h3>
        <h3 v-html="finalScoringHandle(index)"></h3>
      </div>
    </div>
    <!-- 引入项目攻略入口 -->
    <task-strategy :cid="$route.query.cid" :pid="$route.query.pid"></task-strategy>
    <!-- submit -->
    <button :class="['c-submit',bool?'on':'']" @click="submithandle">提交</button>
    <!-- 选择分数 -->
    <van-popup v-model="score_picker" position="bottom" @close="pickerShowClick(false)">
      <van-picker show-toolbar :columns="picker_arr" @cancel="cancel" @confirm="confirm" />
    </van-popup>
  </div>
</template>

<script>
import { index, subtable } from "@/api/course";
import { getStorage, setStorage } from "@/utils/tools";
import { shareCon } from "@/utils/wxconfig";
import TaskStrategy from "@c/course/task-strategy";
export default {
  data() {
    return {
      bodyShow: false,
      title: "",
      list: [],
      userfield: [],
      bool: true,
      word_num: 0,
      star_num: 5,
      score_picker: false,
      picker_arr: [],
      select_obj: {},
      data: {},
      cpuTotal: {}
    }
  },
  components: {
    TaskStrategy
  },
  computed: {
    /*
     *@param:
     *@return:
     *@Description: 判断是不是数组
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-30 19:02:52
     */
    isArray() {
      return function(arr, config) {
        if (arr instanceof Array) {
          arr.forEach((item, index) => {
            if (!item || !config.content.includes(item)) {
              this.$delete(arr, index);
            }
          });
          return arr;
        } else {
          return [];
        }
      };
    },
    /*
     *@param:
     *@return:
     *@Description: 计算总分
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-25 18:21:27
     */
    finalScoringHandle() {
      return function(index) {
        let score = 0;
        let score2 = 1;
        let count = 0;
        for (let i = 1; i < this.list[index - 1].content.length; i++) {
          if (this.list[index - 1].content[i]) {
            score2 = score2 * this.list[index - 1].content[i];
            count++;
          }
        }
        score = count == 3 ? score2 : score;
        this.list[index].content = score;
        this.cpuTotalHandle(index, score);
        return score;
      };
    },
    /*
     *@param: attr key值,variable 存储键值对象,id,index list下标,sIdx 选择框下标
     *@return:
     *@Description: 处理当前点击选项的值
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-25 14:54:56
     */
    selectPicker() {
      return function(attr, variable, id, index, sIdx) {
        this.picker_arr = (() => {
          return variable[attr].content;
        })();
        this.select_obj["id"] = id;
        this.select_obj["attr"] = attr;
        this.select_obj["index"] = index;
        this.select_obj["sIdx"] = sIdx;
        this.score_picker = true;
        this.pickerShowClick(true);
      };
    },
    /*
     *@param:
     *@return:
     *@Description: 计算选择框是否不为真
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-25 18:43:33
     */
    valiSelect() {
      return function(content) {
        let count = 0;
        content.forEach((item, index) => {
          if (item) {
            count++;
          }
        });

        return count == 4 ? false : true;
      };
    }
  },
  methods: {
    preventDefault: function(e) {
      e.preventDefault();
    },
    /*
     *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-28 12:18:35
     */
    pickerShowClick(newval) {
      let self = this;
      if (newval) {
        document.getElementsByTagName("body")[0].addEventListener("touchmove", self.preventDefault, {
            passive: false
          }); //阻止默认事件
      } else {
        document.getElementsByTagName("body")[0].removeEventListener("touchmove", self.preventDefault, {
            passive: false
          }); //打开默认事件
      }
    },
    /*
     *@Description: 计算最大cpu值
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-03 15:46:52
     */
    getMax: function(cpuTotal) {
      let keys = Object.keys(cpuTotal);
      if (keys.length <= 0) {
        return "";
      }
      let max_score = 1;
      let max_name = [];
      for (let i = 0; i < keys.length; i++) {
        let obj = cpuTotal[keys[i]];
        if (obj.score > max_score) {
          max_score = obj.score;
          max_name = [obj.name];
        } else if (obj.score == max_score) {
          max_name.push(obj.name);
        }
      }
      return max_name.join(",");
    },
    /*
     *@Description: 计算乘积最大的
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-03 15:07:06
     */
    cpuTotalHandle(index, score) {
      let str = this.list[index - 1].content[0];
      this.cpuTotal[index] = {
        name: str,
        score: score
      };
    },
    // 选择窗取消函数
    cancel(data) {
      this.score_picker = false;
    },
    // 选择窗确认函数
    confirm(data) {
      let index = this.select_obj.index;
      let id = this.select_obj.id;
      let sIdx = this.select_obj.sIdx;
      this.$set(this.list[index].content, sIdx, data);
      setStorage(this.$route.path, `select${id}`, this.list[index].content);
      this.score_picker = false;
      this.validationHandle();
    },
    // 改变字体颜色
    doFontColor(item) {
      let font = item.label;
      let typeSet = item.config.typeSet ? item.config.typeSet : "";
      let subtitle = item.config.subtitle ? item.config.subtitle : "";
      // small是括号里的说明
      if (typeSet.text instanceof Array) {
        typeSet.text.forEach((item, idx) => {
          font =
            font.replace(item, v => {
              return v.fontcolor(typeSet.color);
            }) +
            (subtitle && subtitle.position != "bottom"
              ? "<span class='small'>" + subtitle.text + "</span>"
              : "");
        });
        return font;
      } else {
        return (
          font.replace(typeSet.text, v => {
            return v.fontcolor(typeSet.color);
          }) +
          (subtitle && subtitle.position != "bottom"
            ? "<span class='small'>" + subtitle.text + "</span>"
            : "")
        );
      }
    },
    // 选择复选框触发
    check(name, content, word, id) {
      this.$forceUpdate();
      if (content.indexOf(name) < 0 && content.length >= word) {
        this.$toast(`最多选择${word}个哦！`);
      } else {
        setStorage(this.$route.path, "id" + id, content);
      }
      this.validationHandle();
    },
    //改变输入框时触发------- 下标、内容、id、字数长度
    textareaChange(index, content, id, word) {
      this.$forceUpdate();
      if (content && content.length > word) {
        this.$set(this.list[index], "content", content.slice(0, word));
        this.$toast(`最多只能输入${word}个字。/(ㄒoㄒ)/~~`);
      } else {
        setStorage(this.$route.path, "id" + id, content);
      }
      this.validationHandle();
    },
    pullData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      index({
        cid: this.$route.query.cid,
        cpid: this.$route.query.pid,
        cptid: this.$route.query.id
      }).then(data => {
        this.$toast.clear();
        if (data.code === 10002) {
          this.$toast(data.data.msg);
          return;
        }

        data.field.forEach((item, index) => {
          if (item.type == "select") {
            data.field[index]["content"] = [];
          }
        });

        this.list = data.field;
        this.userfield = data.userfield;
        document.title = this.$route.query.name;
        this.title = data.title;
        this.data = data;
        this.validationHandle(true);
        this.bodyShow = true;
      });
    },
    validationHandle(bl) {
      let b = true;
      if (this.list && this.list.length == 0) {
        this.bool = false;
        return;
      }
      this.$forceUpdate();
      this.list.forEach((item, index) => {
        // 判断是否是初始化
        if (bl) {
          // 判断是否已提交过数据
          if (this.userfield && this.userfield.length > 0) {
            this.userfield.forEach((item2, key) => {
              if (item2.content && item2.field_id == item.id) {
                if (item.type === "checkbox") {
                  this.list[index].content = item2.content
                    ? this.isArray(item2.content.split(","), item.config)
                    : [];
                } else if (item.type === "select") {
                  this.list[index].content = item2.content
                    ? item2.content.split(",")
                    : [];
                } else {
                  this.list[index].content = item2.content;
                }
              }
            });
            if (!this.list[index].content) {
              this.list[index].content = "";
            }
          } else {
            if (item.type === "checkbox") {
              this.list[index].content = getStorage(
                this.$route.path,
                "id" + item.id
              )
                ? getStorage(this.$route.path, "id" + item.id)
                : [];
            } else if (item.type === "select") {
              this.list[index].content = getStorage(
                this.$route.path,
                `select${item.id}`
              )
                ? getStorage(this.$route.path, `select${item.id}`)
                : [];
            } else {
              this.list[index].content = this.list[index].content
                ? this.list[index].content
                : getStorage(this.$route.path, "id" + item.id)
                ? getStorage(this.$route.path, "id" + item.id)
                : "";
            }
          }
          // 能力结构类型和得分是不可修改，故手动添加到数组
          if (item.type == "evaluation") {
            this.$set(this.list[index], "content", item.config.content);
          }
        }

        // 判读是否有空
        if (
          (this.list[index].type == "select" &&
            this.valiSelect(this.list[index].content)) ||
          ((this.list[index].type == "textarea" ||
            this.list[index].type == "evaluation" ||
            this.list[index].type == "checkbox") &&
            (!this.list[index].content || this.list[index].content == ""))
        ) {
          b = false;
        }
      });
      this.bool = b;
    },
    submithandle() {
      if (this.bool) {
        // loading
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let arr = [];
        this.list.forEach((item, index) => {
          let str = "";
          let b = this.list[index].content instanceof Array ? true : false;
          if (b) {
            str = this.list[index].content.join(",");
          }
          if (
            this.list[index].type != "title" ||
            this.list[index].type != "subtitle"
          ) {
            arr.push({
              field_id: item.id,
              content: b ? str : item.content
            });
          }
        });
        subtable({
          cid: this.$route.query.cid,
          form_id: this.list[0].form_id, //引入form_id都是一样的，所以取一个就可以
          field: JSON.stringify(arr)
        }).then(data => {
          this.$toast.clear();
          this.$toast({
            duration: 1000,
            message: "提交成功！",
            onClose: () => {
              this.$router.push({
                path: "/project_report",
                query: {
                  cid: this.$route.query.cid,
                  cpid: this.$route.query.pid,
                  taskid: this.$route.query.id
                }
              });
            }
          });
        });
      }
    }
  },
  created() {
    this.pullData();
    shareCon("course2", this);
  }
};
</script>

<style lang="scss" scope>
body {
  background-color: #f0f0f0;
}
input-placeholder {
  /* Internet Explorer 10+ */
  color: #999;
}
.c2-task-main {
  padding: 40px 30px 80px;
  text-align: center;
  h2 {
    font-size: 36px;
    color: #333333;
    text-align: center;
    font-weight: bold;
  }
  .c2-task-group {
    margin-top: 40px;
    position: relative;
    h3 {
      text-align: left;
      font-size: 32px;
      // color: #EA345C;
      .small {
        font-size: 24px;
        color: #666;
      }
    }
    h4 {
      text-align: left;
      font-size: 32px;
      color: #333333;
      margin-top: 20px;
      line-height: 1;
    }
    .star {
      padding-top: 30px;
      text-align: left;
      img {
        width: 38px;
        height: 38px;
        margin-right: 40px;
      }
    }
    .pdl3 {
      padding-left: 30px;
    }
    .c2-textarea {
      margin-top: 20px;
      height: 160px;
      border-radius: 8px;
      background-color: #fff;
      border: 0;
      width: 100%;
      padding: 22px 20px;
      font-size: 26px;
      resize: none;
      text-align: left;
    }
    .c2-word-limit {
      position: absolute;
      font-size: 18px;
      color: #999;
      bottom: 14px;
      right: 16px;
    }
  }
  .c2-task-group.text {
    margin-top: 20px;
    input {
      border: none;
      line-height: 70px;
      border-radius: 8px;
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .c2-task-group.subtitle {
    margin-top: 15px;
    h3 {
      font-size: 24px;
      color: #666666;
    }
  }
  .c-submit {
    width: 174px;
    height: 66px;
    background: #cccccc;
    border-radius: 33px;
    font-size: 34px;
    color: #ffffff;
    border: 0;
    margin: 80px auto auto;
  }
  .c-submit.on {
    background-color: #ea345c;
  }
  // select
  .task-select-group {
    margin-top: 28px;
    h3 {
      font-size: 28px;
      text-align: left;
      margin-bottom: 15px;
    }
    .select-group {
      position: relative;
      text-align: left;
      input {
        line-height: 70px;
        border-radius: 8px;
        border: none;
        // width: 100%;
      }
      img {
        position: absolute;
        right: 20px;
        top: 27px;
        width: 27px;
        height: 16px;
      }
    }
    .flex-select-group {
      margin-top: 16px;
      display: flex;
      flex-wrap: wrap;
      align-content: space-around;
      .select-group {
        margin-right: 14px;
        width: 220px;
        input {
          width: 100%;
          font-size: 26px;
          padding-left: 20px;
          box-sizing: border-box;
        }
        &:last-child {
          margin-right: 0;
        }
      }
      .select-group.on {
        margin-right: 0;
        width: 100%;
        margin-bottom: 16px;
        input {
          width: 100%;
        }
      }
    }
  }
  .calculating-group {
    display: flex;
    h3 {
      font-size: 26px;
      text-align: left;
      margin-top: 15px;
      color: #333333;
      margin-right: 14px;
    }
  }
}
.cpuTotal {
  padding-left: 30px;
  font-size: 32px;
}
</style>
<style >
.c2-task-checkbox .van-checkbox-group {
  width: 100%;
  font-size: 0;
  /* padding-top: 20px; */
  border-radius: 8px;
}
.c2-task-checkbox .van-checkbox-group .van-checkbox {
  width: 154px;
  display: inline-block;
  font-size: 0;
  margin-right: 83px;
  font-size: 26px;
  margin-top: 30px;
  text-align: left;
}
.c2-task-checkbox .van-checkbox-group .van-checkbox.c2-checkbox {
  margin-top: 20px;
}
.c2-task-checkbox .van-checkbox-group .van-checkbox:nth-child(3n + 3) {
  margin-right: 0px;
}
.c2-task-checkbox .van-checkbox-group .van-checkbox .van-checkbox__label {
  position: relative;
  z-index: 2;
  padding: 0px 0px 0px 45px;
  margin-left: -35px;
  /* line-height:1; */
  font-size: 26px;
}
.c2-task-checkbox .van-checkbox-group .van-checkbox .van-checkbox__icon {
  height: auto;
  line-height: 1;
}
.c2-task-checkbox
  .van-checkbox-group
  .van-checkbox
  .van-checkbox__icon
  .van-icon {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 0;
  border-color: transparent;
  background-color: transparent;
  background-image: url(../../../assets/normal.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.c2-task-checkbox
  .van-checkbox-group
  .van-checkbox__icon.van-checkbox__icon--checked
  .van-icon.van-icon-success {
  background-image: url(../../../assets/c2-task-check.png);
}
.c2-task-checkbox
  .van-checkbox-group
  .van-checkbox
  .van-checkbox__icon
  .van-icon:before {
  content: "";
}
</style>